import React from 'react'
import PropTypes from 'prop-types'
import CustomChart from './CustomChart'
import useStatisticChart from '../../../../hooks/useStatisticChart'
import { downloadTypes } from '../../../../constants/statistics'

const FormsChart = ({ results }) => {
  const headerNames = {
    all: 'Todos',
    simple: 'Form. simples',
    template: 'Form. de plantillas',
    quick_search: 'Form. de consultas rápidas',
    procedure: 'Form. de gestión de trámites'
  }
  const { chartData, chartTime } = useStatisticChart(results, ['Años', 'Formularios creados'], headerNames)

  return (
    <CustomChart
      chartData={chartData}
      horizontalTitle={chartTime}
      verticalTitle="Cantidad de formularios"
      title="Formularios creados"
      description="Encuentra la cantidad de formularios creados. Puedes usar los filtros para búsquedas específicas."
      downloadAvailable={[downloadTypes.picture, downloadTypes.monthlyExcel]}
      excelKindDownload="monthly_forms"
    />
  )
}

export default FormsChart

FormsChart.propTypes = {
  results: PropTypes.object.isRequired
}
